import { LazyLoad } from '@petconsole/pure-fe-mui';

const BusSupplyAdmin = LazyLoad(() => import('./BusSupplyAdmin'));

export { BusSupplyAdmin };
